module.exports = new __parcel__URL__("dark-mode.fd95cecc.svg").toString();